import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const content: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  padding: (p) => p.spacing(1),
  gap: (p) => p.spacing(1),
};
